import { render, staticRenderFns } from "./MyRequestPV.vue?vue&type=template&id=89986240&lang=pug"
import script from "./MyRequestPV.vue?vue&type=script&lang=js"
export * from "./MyRequestPV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports